import React from 'react'

/* global google */

let loadingStarted = false
let loaded = false
const onLoad = []

class Chart extends React.Component {
  constructor() {
    super()
    this.drawn = false
    if (typeof window !== 'undefined' && !loadingStarted) {
      google.charts.load('current', { packages: ['corechart'] })
      google.charts.setOnLoadCallback(() => {
        onLoad.forEach(f => f())
        loaded = true
      })
    }
    loadingStarted = true
  }
  componentDidMount() {
    if (typeof window === 'undefined') return
    const init = () => {
      this.chart = new google.visualization.PieChart(this.div)
      this.dataTable = google.visualization.arrayToDataTable(this.props.data)
      this.draw()
      this.drawn = true
    }
    if (loaded) init()
    else onLoad.push(init)
  }
  componentDidUpdate(prevProps) {
    if (this.drawn && this.props.data !== prevProps.data) {
      this.dataTable = google.visualization.arrayToDataTable(this.props.data)
      this.draw()
    }
  }
  draw() {
    this.chart.draw(this.dataTable, this.props.options)
  }
  render() {
    return (
      <div
        style={{
          display: 'inline-block',
          width: this.props.options.width,
          height: this.props.options.height,
        }}
        ref={div => {
          this.div = div
        }}
        className={this.props.className}
      />
    )
  }
}

Chart.propTypes = {
  options: React.PropTypes.any.isRequired, // eslint-disable-line react/forbid-prop-types
  data: React.PropTypes.any.isRequired, // eslint-disable-line react/forbid-prop-types
  className: React.PropTypes.string,
}

Chart.defaultProps = {
  className: '',
}

export default Chart



// WEBPACK FOOTER //
// ./components/visual/Chart.js